import { Form } from "antd";
import styled from "styled-components";

const { Item } = Form;

export const StructureContainer = styled.div`
  display: grid;
  margin-right: 65%;
  align-items: center;
  grid-column-gap: 10px;
  margin-top: 20px;

  ul li {
    margin-left: 40px;
    margin-top: 5px;
  }
`;

export const FirstLine = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 16px;
  margin-top: 20px;
  max-width: 400px;
  width: 100%;
`;

export const FormItemFieldName = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-size: ${(props) => props.theme["@medium-font-size"]};

    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }

    box-shadow: none;

    &:hover {
      border-color: ${(props) => props.theme["@secondary-color"]};
    }
  }

  .ant-form-item-control {
    width: 100%;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }
  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    }
  }
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector,
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    outline: 1.6px solid ${(props) => props.theme.colors.text};
    outline-offset: 1.6px;
    align-items: center;
  }

  .ant-form-item-label {
    display: flex !important;
    min-width: 100%;
    max-width: 100%;
    padding: 6px 0;
    height: auto !important;
    z-index: 1;
    pointer-events: none !important;

    > label {
      font-family: ${(props) => props.theme["@font-family"]};
      font-size: ${(props) => props.theme["@medium-font-size"]};
      font-weight: ${(props) => props.theme["@bold-font-weight"]};
      line-height: 1.4;
    }
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
  }

  .ant-form-item-required::before {
    content: "" !important;
  }
`;
